import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";

interface Props {
  isVisible: boolean;
  setIsVisible: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
  subTitle: string;
  btnLabel: string;
  btnClick: () => void;
}

export function OneBtnModal({
  isVisible,
  setIsVisible,
  title,
  subTitle,
  btnLabel,
  btnClick,
}: Props) {
  const handleCancelBtn = () => {
    setIsVisible(false);
  };

  return (
    <Transition.Root show={isVisible} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-[999999999999]"
        onClose={()=>{}}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-80 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-[20px]">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="transition-al relative mx-auto flex h-[300px] w-[424px] transform flex-col items-center justify-center overflow-hidden rounded-[16px] bg-white px-[40px] pb-[50px] pt-[76px]">
                <p className="m-0 mb-[14px] text-[26px] font-bold leading-[32px] text-[#2d2d2d]">
                  {title}
                </p>
                <p className="m-0 text-[20px] font-medium leading-[25px] text-gray-3">
                  {subTitle}
                </p>
                <button
                  className="mt-[46px] h-[77px] w-full rounded-[12px] border-none bg-black text-R1 text-white"
                  onClick={() => {
                    setIsVisible(false);
                    btnClick();
                  }}
                >
                  {btnLabel}
                </button>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
